import Footer from "../../../components/Footer/Footer";
import NavBar from "../../../components/NavBar/NavBar";

import Title from "../../../components/Title/Title";
import CustomButton from "../../../components/Custom-Button/CustomButton";

export default function SecondCommandment() {

    return (
        <div>
            <NavBar/>
            <Title text={"Não Tomar Seu Santo Nome em Vão."}/>

            <p className="info-text">
            Este mandamento pede fé, esperança e caridade em Deus[5]. Deus revela ser único e fiel, e espera que O adoremos com todo o coração[5].<br/>
            O CIC diz que amá-Lo sobre todas as coisas é o primeiro dever: aceitar Seus desígnios (“obediência da fé”) e rejeitar tudo que se oponha a isso[6][7]. <br/>
            Pecados contra este mandamento incluem descrença, idolatria (colocar outras coisas no lugar de Deus) e ingratidão[8][9].<br/>
            O Catecismo enfatiza que, por causa deste mandamento, Jesus resume que devemos amar Deus com toda a alma (Mc 12,29-30)[10].<br/>
            Assim, confiar totalmente em Deus (fé plena), esperar só n’Ele (esperança) e amá-Lo acima de tudo (caridade) são exigidos[5][7].
            </p> 

            <Title text={"Aplicação Cotidiana"}/>
            <p className="info-text">
            Viver este mandamento implica tratar com seriedade as palavras e promessas feitas em nome de Deus. <br/>
            Praticamente, evita-se usar expressões de desrespeito como “Jesus Cristo!” de modo leviano, xingamentos com o nome de Deus ou de santos, e juramentos fúteis. <br/>
            Também significa cumprir compromissos sérios (como casamento ou acordos) honestamente. <br/>
            O catecismo recomenda apenas jurar por Deus em situações graves (por exemplo, em tribunal, Mt 5,34-36)[21][19], respeitando assim a Sua presença em nossa vida. <br/>
            Evitar especular ou brincar com símbolos sagrados (maus tratos à hóstia, por exemplo) também faz parte desse mandamento.            
            </p> 

            <Title text={"Aspectos Teológicos"}/>

            <p className="info-text">
            O mandamento reflete que Deus é verdade e Seu Nome envolve Sua autoridade. Blasfemar ou mentir sobre Deus é um pecado grave por ofender o próprio Deus[17]. <br/>
            A Igreja destaca a virtude da religião: reconhecer e honrar Deus em atos de culto e na vida diária[12][14]. <br/>
            Em suma, invocar Deus é “tomar-O como testemunha” (Dt 6,13)[21], e isso só deve ser feito com propósito sério e verdadeiro. <br/>
            O fiel dá testemunho de Deus confessando a fé sem medo[22], e evita tudo que profane Sua santidade.
            </p> 


            <CustomButton route={"/Mandamentos"} text={"Voltar"}/>
            <Footer/>
        </div>
    )
}